import React from "react";
import { Badge } from "@bookingcom/bui-react";
import { useI18n } from "@bookingcom/lingojs-react";
import useUserAgent from "../../../../hooks/useUserAgent.js";
import styles from "./BaseFareAttributes.module.css";
const FEATURE_CATEGORY_TO_BADGE_COPY_MAP = {};
const BaseFareAttributes = ({ flight }) => {
    const i18n = useI18n();
    const { isMobile } = useUserAgent();
    const { brandedFareInfo } = flight;
    const badgesToRender = Object.keys(FEATURE_CATEGORY_TO_BADGE_COPY_MAP)
        .filter((categoryToRender) => brandedFareInfo?.features.some(({ category }) => category === categoryToRender))
        .map((categoryToRender) => {
        const copy = FEATURE_CATEGORY_TO_BADGE_COPY_MAP[categoryToRender];
        return React.createElement(Badge, { text: i18n.trans(copy), className: styles.attributeBadge, key: categoryToRender });
    });
    return badgesToRender.length > 0 ? (React.createElement("div", { className: isMobile ? styles.rootMobile : undefined }, badgesToRender)) : null;
};
export default BaseFareAttributes;
